import documentReady from 'document-ready';
import Ajax from 'legacy/ajax';
import $ from 'legacy/jquery';
import Message from 'legacy/message';
import { Validator } from 'legacy/validation';

documentReady(() => {
  // @ts-expect-error - TS7034 - Variable '$form' implicitly has type 'any' in some locations where its type cannot be determined.
  let $form;

  function registerEvents() {
    $form = $('#forgot_password_form');
    $form.validateOn('submit', validate, submit, { scroll: false });
  }

  function validate() {
    const validator = new Validator(),
      m = Message.Common.Validation;
    const emailField = $('#user_email');

    const notBlank = validator
      .withMessage(m.InvalidEmailAddress)
      .validate(emailField)
      .notBlank();

    if (notBlank) {
      validator.withMessage(m.InvalidEmailAddress).validate(emailField).email();
    }

    return validator;
  }

  function submit() {
    // @ts-expect-error - TS7005 - Variable '$form' implicitly has an 'any' type.
    const $button = $form.find('button');
    $button.addClass('loading');

    Ajax.submit({
      // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
      formSelector: this,
      errorMessage: Message.ResetPassword.ErrorSendingEmail,
      pendingMessage: null,
      always: function () {
        $button.removeClass('loading');
      },
    });

    return false;
  }

  registerEvents();
});
